var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuleViolationTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 316,
    viewBox: "0 0 312 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.001 107.979L270.727 108.529L263.382 64.4328C262.821 61.0655 259.908 58.597 256.5 58.597H31.107C28.1861 58.597 25.4077 59.8804 23.513 62.1074C21.6194 64.3388 20.7981 67.2857 21.2608 70.1701L46.2979 225.834C47.7162 234.662 53.7478 241.222 62.6757 241.222H290.566L290.563 244.549H62.6774C52.0346 244.549 44.7083 236.884 43.0189 226.367L17.9773 70.7023C17.3578 66.8521 18.46 62.9213 20.9863 59.952C23.5126 56.9827 27.2108 55.27 31.1097 55.27H256.499C261.536 55.27 265.829 58.9145 266.658 63.8871L274.001 107.979Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.859 126.548C209.465 150.299 213.07 174.051 216.676 197.802L205.859 126.548Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.282 83.6133H22.8496V86.941H269.282V83.6133Z",
    fill: "#151515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.019 65.0464C39.7168 65.0464 42.7187 68.0534 42.7187 71.7494C42.7187 75.4526 39.7168 78.4598 36.019 78.4598C32.3212 78.4598 29.3193 75.4526 29.3193 71.7494C29.3193 68.0534 32.3212 65.0464 36.019 65.0464ZM36.019 68.3692C34.1551 68.3692 32.6423 69.8834 32.6423 71.7494C32.6423 73.6226 34.1551 75.137 36.019 75.137C37.8829 75.137 39.3957 73.6226 39.3957 71.7494C39.3957 69.8834 37.8829 68.3692 36.019 68.3692Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7783 65.0464C57.476 65.0464 60.4779 68.0534 60.4779 71.7494C60.4779 75.4526 57.476 78.4598 53.7783 78.4598C50.0805 78.4598 47.0786 75.4526 47.0786 71.7494C47.0786 68.0534 50.0805 65.0464 53.7783 65.0464ZM53.7783 68.3692C51.9144 68.3692 50.4016 69.8834 50.4016 71.7494C50.4016 73.6226 51.9144 75.137 53.7783 75.137C55.6422 75.137 57.155 73.6226 57.155 71.7494C57.155 69.8834 55.6422 68.3692 53.7783 68.3692Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5371 65.0464C75.2348 65.0464 78.2367 68.0534 78.2367 71.7494C78.2367 75.4526 75.2348 78.4598 71.5371 78.4598C67.8393 78.4598 64.8374 75.4526 64.8374 71.7494C64.8374 68.0534 67.8393 65.0464 71.5371 65.0464ZM71.5371 68.3692C69.6731 68.3692 68.1604 69.8834 68.1604 71.7494C68.1604 73.6226 69.6731 75.137 71.5371 75.137C73.401 75.137 74.9138 73.6226 74.9138 71.7494C74.9138 69.8834 73.401 68.3692 71.5371 68.3692Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.837 248.456L136.78 249.994L110.378 300.737C109.092 303.221 109.184 306.199 110.636 308.591C112.089 310.991 114.676 312.446 117.475 312.446H215.129V315.775H117.475C113.519 315.775 109.845 313.711 107.799 310.321C105.745 306.931 105.608 302.718 107.434 299.206L133.837 248.456Z",
    fill: "#151515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.665 247.625L145.617 249.164L118.385 301.506C117.913 302.405 117.951 303.487 118.476 304.356C119.001 305.232 119.944 305.757 120.964 305.757H227.008V309.086H120.964C118.788 309.086 116.765 307.951 115.639 306.085C114.506 304.218 114.43 301.903 115.441 299.968L142.665 247.625Z",
    fill: "#151515"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.018 247.639L200.977 249.147L171.022 308.178L168.055 306.67L198.018 247.639Z",
    fill: "#151515"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.003 248.387H144.244L138.27 260.426H193.099L199.003 248.387Z",
    fill: "#151515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.536 213.781C261.383 219.132 257.55 223.839 252.091 223.839H105.199C99.6054 223.839 94.4425 219.292 93.5691 213.781C82.8837 146.448 72.2047 79.1144 61.5257 11.7812C60.678 6.43052 64.5116 1.72949 69.97 1.72949H216.856C222.456 1.72949 227.619 6.27618 228.492 11.7812C239.171 79.1144 249.85 146.448 260.536 213.781Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.775 213.588C262.745 219.717 258.346 225.093 252.092 225.093H105.199C99.0147 225.093 93.2932 220.07 92.3299 213.98L60.2864 11.9806C59.3103 5.8518 63.7155 0.46875 69.9701 0.46875H216.856C223.047 0.46875 228.762 5.49786 229.732 11.5881L261.775 213.588ZM259.297 213.98L227.253 11.9806C226.47 7.05441 221.859 2.9834 216.856 2.9834H69.9701C65.3016 2.9834 62.0395 7.01559 62.7651 11.5881L94.8087 213.588C95.5921 218.508 100.196 222.578 105.199 222.578H252.092C256.754 222.578 260.022 218.552 259.297 213.98Z",
    fill: "#151515"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.264 177.365H105.876V179.878H233.264V177.365Z",
    fill: "#DFE1E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.069 189.07H107.733V191.584H225.069V189.07Z",
    fill: "#DFE1E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.431 155.725L170.511 154.11L173.087 151.041C179.866 142.971 192.126 144.591 199.423 150.901H199.429C202.811 153.825 207.192 155.689 211.691 155.689C215.669 155.689 219.609 154.126 222.197 151.046L222.282 150.943C225.324 147.323 229.939 145.448 234.617 145.448V147.962C230.673 147.962 226.768 149.509 224.202 152.563L224.118 152.667C221.052 156.312 216.403 158.202 211.691 158.202C206.594 158.202 201.621 156.12 197.789 152.807L197.783 152.802C191.473 147.349 180.87 145.677 175.007 152.661L172.431 155.725Z",
    fill: "#DFE1E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.105 156.513L102.185 154.898L104.761 151.829C111.54 143.759 123.8 145.379 131.097 151.689H131.102C134.485 154.613 138.866 156.477 143.365 156.477C147.343 156.477 151.283 154.914 153.871 151.834L153.956 151.731C156.998 148.111 161.613 146.236 166.291 146.236V148.75C162.347 148.75 158.441 150.297 155.876 153.351L155.792 153.455C152.726 157.1 148.077 158.991 143.365 158.991C138.268 158.991 133.295 156.908 129.463 153.595L129.457 153.59C123.147 148.137 112.543 146.465 106.681 153.45L104.105 156.513Z",
    fill: "#DFE1E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.454 17.2271C169.164 17.2271 122.875 17.2271 76.585 17.2271C82.5462 54.8177 88.5074 92.4017 94.4686 129.992C140.758 129.992 187.055 129.992 233.344 129.992C227.377 92.4017 221.415 54.8177 215.454 17.2271Z",
    fill: "#151515"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.693 17.0333L234.583 129.792C234.641 130.154 234.531 130.529 234.299 130.807C234.06 131.084 233.705 131.246 233.344 131.246H94.4685C93.8556 131.246 93.3266 130.8 93.2298 130.186L75.3397 17.4274C75.288 17.0591 75.3913 16.6906 75.63 16.4128C75.8687 16.135 76.2171 15.9736 76.5848 15.9736H215.454C216.073 15.9736 216.596 16.4195 216.693 17.0333ZM214.383 18.4871H78.0493L95.5394 128.733H231.873L214.383 18.4871Z",
    fill: "#151515"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.425 74.3607C123.431 55.6091 136.595 40 155.556 40C174.993 40 192.529 55.1332 195.618 74.3607C198.564 92.9219 184.925 108.057 166.344 108.057C147.24 108.057 129.419 93.3979 126.425 74.3607Z",
    fill: "#9E007E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.018 63.7158L143.218 57.4917L183.073 84.3815L178.869 90.6105L139.018 63.7158Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.359 52.0151L177.586 56.2095L150.729 96.0859L144.496 91.8877L171.359 52.0151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleViolationTile);
export default __webpack_public_path__ + "static/media/rule-violation-tile.baf127dc90921231a947211321013cbd.svg";
export { ForwardRef as ReactComponent };